/**
 * Which build is this browser actually running?
 *
 * Motivated by a real support case: a user scanned minutes after a deploy from a tab
 * loaded before it, and reported the old UI as a bug. The version is baked into the
 * bundle at build time (git SHA via the Docker build-arg), shown in the nav so every
 * screenshot self-identifies, and compared against the server's /version.json to detect
 * exactly that stale-tab scenario (see useVersionCheck).
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? 'dev'

/** Short-SHA form for the nav; the full version lives in the title tooltip. */
export const SHORT_VERSION: string = APP_VERSION.slice(0, 7)
